<template>
  <b-field grouped>
    <base-select
      :service="$options.codeService"
      fetch-func="listTypes"
      label="Type"
      :value.sync="filters.type"
      value-key="type"
      label-key="type"
    />
    <base-select
      :service="$options.firmService"
      fetch-func="firmAssociations"
      :fetch-params="{
        child_id: $store.state.Auth.user.firmId,
        includes: 'parentFirm'
      }"
      label="Firm"
      :value.sync="filters.firm_firm_id"
      label-key="parentFirm.name"
      :show-default-option="false"
      ref="selectFirm"
    />
    <div class="field">
      <label class="label is-invisible">Actions</label>
      <div class="buttons">
        <button class="button" @click="reset">Reset</button>
        <button class="button is-dark" @click="filter">Filter</button>
        <slot name="buttons" />
      </div>
    </div>
  </b-field>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import { CodeService } from "@/services/code.service";
import { AssociatedService } from "@/services/associated.service";
import { FirmService } from "@/services/firm.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";

export default {
  associatedService: AssociatedService,
  codeService: CodeService,
  firmService: FirmService,
  components: {
    BaseSelect
  },
  data: () => ({
    filters: {}
  }),
  async mounted() {
    // Trigger filter once firm_firm_id filter is set
    await this.$refs.selectFirm.fetchOptions();
    // // Fetch parent firm associations (reverse relationship)
    // const parentAssociations = await FirmService.firmAssociations({ child_id: this.$store.state.Auth.user.firmId, includes: "firm" })
    //   .then(response => JsonDenormalizer.denormalize(response));
    // // Append parent firm associations
    // this.$refs.selectFirm.options.push(...(parentAssociations || []));
    if (this.$refs.selectFirm.options.length) {
      // this.$set(this.filters, "firm_firm_id", this.$refs.selectFirm.options[0].id);
      this.$refs.selectFirm.selectFirstOption();
      this.$nextTick(() => {
        this.filter();
      });
    }
  },
  methods: {
    filter() {
      let filters = {};

      Object.keys(this.filters).forEach(key => {
        if (this.filters[key] !== "") {
          filters[key] = this.filters[key];
        }
      });

      this.$emit("filter", filters);
    },
    reset() {
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = "";
      });
      this.$nextTick(() => {
        this.$refs.selectFirm.selectFirstOption();
        this.$nextTick(() => {
          this.filter();
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Codes/list/partials/filters.vue